import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsService } from '../services/api';

const getOrCreateSessionId = () => {
  const key = 'pageViewSessionId';
  try {
    const existing = localStorage.getItem(key);
    if (existing) return existing;
    const newId = typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    localStorage.setItem(key, newId);
    return newId;
  } catch {
    return null;
  }
};

const PageViewTracker = () => {
  const location = useLocation();

  const sessionId = useMemo(() => getOrCreateSessionId(), []);

  useEffect(() => {
    const path = `${location.pathname}${location.search || ''}`;
    analyticsService.trackPageView(path, {
      sessionId,
      referrer: typeof document !== 'undefined' ? document.referrer : null,
    }).catch(() => {
      // best-effort
    });
  }, [location.pathname, location.search, sessionId]);

  return null;
};

export default PageViewTracker;
